import {useSearchParams} from '@github-ui/react-router'

import {useCurrentBlame} from './CurrentBlame'
import {useCurrentBlob} from './CurrentBlob'

export const BlobDisplayType = {
  FileRenderer: 'FileRenderer',
  Image: 'Image',
  TooLargeError: 'TooLargeError',
  CSV: 'CSV',
  Markdown: 'Markdown',
  IssueTemplate: 'IssueTemplate',
  Code: 'Code',
} as const

export type BlobDisplayType = (typeof BlobDisplayType)[keyof typeof BlobDisplayType]

export function useBlobRendererType(): BlobDisplayType {
  const payload = useCurrentBlob()
  const blame = useCurrentBlame()
  const [urlParams] = useSearchParams()

  // Use URL as the source of truth for short_path intent, but only render
  // FileRenderer when the payload data agrees (is fresh). This avoids rendering
  // the iframe with a stale identity during re-fetch, consistent with how
  // README previews stay visible until code data arrives.
  const hasShortPath = !!urlParams.get('short_path')

  if (payload.renderedFileInfo && !hasShortPath && !payload.shortPath && !blame) {
    return BlobDisplayType.FileRenderer
  } else if (payload.renderImageOrRaw) {
    if (payload.image) {
      return BlobDisplayType.Image
    } else {
      return BlobDisplayType.TooLargeError
    }
  } else if (payload.csv && !blame) {
    return BlobDisplayType.CSV
  } else if ((payload.richText || payload.richTextTruncated) && !blame) {
    return BlobDisplayType.Markdown
  } else if (
    ((payload.issueTemplate?.structured && payload.issueTemplate.valid) ||
      (payload.discussionTemplate && payload.discussionTemplate.valid)) &&
    !blame &&
    !payload.isPlain
  ) {
    return BlobDisplayType.IssueTemplate
  } else {
    return BlobDisplayType.Code
  }
}
